import React, { useState } from "react";
import { ListItem, ListItemText, Collapse, Box } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";

import { Menu } from "../../model/menu";

export interface SidebarItemProps {
  menu: Menu;
  mergedPath: string;
  padding?: number;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ menu, mergedPath, padding }) => {
  /* hooks */
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { icon: Icon } = menu;
  const paddingValue = padding ?? 0;
  const fullPath = menu.path ? `${mergedPath}${menu.path}` : mergedPath;

  const isActive = menu.path ? (location.pathname === fullPath || location.pathname.startsWith(fullPath + "/")) : false;

  // Check if any child item is active
  const hasActiveChild = menu.child?.some(child => {
    const childPath = `${fullPath}${child.path}`;
    return location.pathname === childPath || location.pathname.startsWith(childPath + "/");
  });

  // Set initial open state based on active child
  React.useEffect(() => {
    if (hasActiveChild) {
      setOpen(true);
    }
  }, [hasActiveChild]);

  return (
    <div>
      {menu.child ? (
        <Box>
          <ListItem 
            button 
            onClick={() => setOpen(!open)} 
            sx={{ 
              py: 1, 
              pl: paddingValue,
              backgroundColor: hasActiveChild ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
            }}
          >
            <Icon fontSize="small" style={{ marginRight: "5px" }} color="action" />
            <ListItemText primary={menu.name} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {menu.child.map((child, index) => (
              <SidebarItem
                key={`${index}-${child.name}`}
                menu={child}
                mergedPath={fullPath}
                padding={paddingValue + 4}
              />
            ))}
          </Collapse>
        </Box>
      ) : menu.path ? (
        <Link to={fullPath} style={{ color: "inherit", textDecoration: "inherit" }}>
          <div className={isActive ? "active-menu" : ""}>
            <ListItem button sx={{ py: 1, pl: paddingValue }}>
              <Icon fontSize="small" style={{ marginRight: "5px" }} color="action" />
              <ListItemText>{menu.name}</ListItemText>
            </ListItem>
          </div>
        </Link>
      ) : (
        <ListItem button sx={{ py: 1, pl: paddingValue }}>
          <Icon fontSize="small" style={{ marginRight: "5px" }} color="action" />
          <ListItemText>{menu.name}</ListItemText>
        </ListItem>
      )}
    </div>
  );
};

export default SidebarItem;
